var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatinumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.846,
    height: 15.877,
    viewBox: "0 0 19.846 15.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "9n6f0te0ba",
    x1: 1.226,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9ebf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ac5db"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M3.7 0 0 11.068 8.938 0z",
    transform: "translate(10.908 4.171)",
    style: {
      fill: "url(#9n6f0te0ba)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M2.839 0 0 3.22h4.827z",
    transform: "translate(.042 .256)",
    style: {
      fill: "url(#9n6f0te0ba)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M1.988 0 0 3.22h4.827z",
    transform: "translate(14.977 .256)",
    style: {
      fill: "url(#9n6f0te0ba)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M5.24 0H0l8.938 11.068z",
    transform: "translate(0 4.171)",
    style: {
      fill: "url(#9n6f0te0ba)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "m0 0 3.449 3.259L5.46 0z",
    transform: "translate(10.811)",
    style: {
      fill: "url(#9n6f0te0ba)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "m0 0 2.012 3.259L5.46 0z",
    transform: "translate(3.575)",
    style: {
      fill: "url(#9n6f0te0ba)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "m0 0 3.912 11.706L7.824 0z",
    transform: "translate(6.011 4.171)",
    style: {
      fill: "url(#9n6f0te0ba)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M3.526 0 0 3.332h7.052z",
    transform: "translate(6.397 .144)",
    style: {
      fill: "url(#9n6f0te0ba)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinumIcon);
export default __webpack_public_path__ + "static/media/platinum-icon.d1aaf5c03ac0d535493dd19f0d953972.svg";
export { ForwardRef as ReactComponent };